import React from "react";

type Props = {
    message: string | null;
};

class Loader extends React.Component<Props> {
    render() {
        return (
            <div className="loader-wrapper">
                <div className="loader" />
                <div className="text-center">
                    {this.props.message ? <p className="loader-text">{this.props.message}</p> : null}
                </div>
            </div>
        );
    }
}

export default Loader;
